<template>
  <div>
    <el-dialog
      :modal-append-to-body="false"
      append-to-body
      title="标识码"
      :visible.sync="show"
      width="200mm"
      :before-close="handleClose"
    >
      <div class="dialog-footer" v-loading="loading">
        <el-button @click="show = false">取 消</el-button>
        <el-button style="margin-left: 10px" type="primary" @click="print">打 印</el-button>
      </div>

      <div v-loading="loading" v-if="show">
        <div id="printBox">
          <div class="page" v-for="(item, index) in qrcodeList" :key="item">
            <div class="box">
              <div class="box-title border-b">
                {{ item.projectName }}
                <div class="box-title-info">设备</div>
              </div>
              <div class="box-item width-1 border-b">
                <div class="box-l border-r">设备名称:</div>
                <div class="box-r" :style="'font-size:' + item.deviceNameSize + 'pt;'">{{ item.name }}</div>
              </div>
              <div class="box-item width-1 border-b">
                <div class="box-l border-r">设备型号:</div>
                <div class="box-r" :style="'font-size:' + item.deviceModelSize + 'pt;'">{{ item.model }}</div>
              </div>
              <div class="box-item width-2 border-r border-b">
                <div class="box-l border-r">设备编号:</div>
                <div class="box-r" :style="'font-size:' + item.deviceCodeSize + 'pt;'">{{ item.codeNo }}</div>
              </div>
              <div class="box-item width-2 border-r border-b">
                <div class="box-l border-r">所属部门:</div>
                <div class="box-r" :style="'font-size:' + item.deptNameSize + 'pt;'">
                  {{ item.deptName }}
                </div>
              </div>
              <div class="box-item width-2 border-r">
                <div class="box-l border-r">启用日期:</div>
                <div class="box-r" :style="'font-size:' + item.startUseTimeSize + 'pt;'">{{ item.startUseTime }}</div>
              </div>
              <div class="box-qrcode" :id="'qrcode' + index">{{ getQrcodeBydom(index, item) }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>
.dialog-footer {
  text-align: right;
  margin-bottom: 20px;
}

.page {
  box-sizing: border-box;
  width: 120mm;
  height: 78mm;
  padding: 4mm 7mm 4mm 7mm;
  margin: 0 auto;
  border: 0.5mm #d3d3d3 solid;
  border-radius: 2mm;
  background: white;
  overflow: hidden;
  color: #000;
  box-shadow: 0 0 1mm rgba(0, 0, 0, 0.1);
}

.border-b {
  border-bottom: solid #000 0.5mm;
}

.border-r {
  border-right: solid #000 0.5mm;
}

.box {
  position: relative;
  box-sizing: border-box;
  border: solid #000 0.5mm;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 13pt;
}

.box-title {
  position: relative;
  width: 100%;
  flex: 1;
  font-size: 16pt;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
}

.box-title-info {
  position: absolute;
  right: 2mm;
  bottom: 2mm;
  font-size: 11pt;
}

.box-item {
  height: 11mm;
  display: flex;
  align-items: center;
}

.width-1 {
  width: 100%;
}

.width-2 {
  width:calc(100% - 35mm);
}

.box-l {
  padding-left: 2mm;
  width: 20mm;
  height: 100%;
  display: flex;
  align-items: center;
}

.box-r {
  padding-left: 2mm;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
}

.box-qrcode {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 32mm;
  height: 32mm;
  padding: 1mm;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<script>
import request from '@/util/request';
import qrcode from 'qrcodejs2';
const getQrcode = (params, options) => request.post('/api/mark/manage/addresses', params, options);
export default {
  data() {
    return {
      loading: false,
      show: false,
      qrcodeList: [],
      moduleType: '',
      liNumberLength: ''
    };
  },
  methods: {
    // 打印方法
    print() {
      let dom = document.getElementById('printBox').outerHTML;
      var win = window.open();
      self.focus();
      win.document.open();
      let st = `
                <style >
.page {
  box-sizing: border-box;
  width: 120mm;
  height: 78mm;
  padding: 4mm 7mm 4mm 7mm;
  margin: 0 auto;
  border: 0.5mm #d3d3d3 solid;
  border-radius: 2mm;
  background: white;
  overflow: hidden;
  color: #000;
  box-shadow: 0 0 1mm rgba(0, 0, 0, 0.1);
}

.border-b {
  border-bottom: solid #000 0.5mm;
}

.border-r {
  border-right: solid #000 0.5mm;
}

.box {
  position: relative;
  box-sizing: border-box;
  border: solid #000 0.5mm;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 13pt;
}

.box-title {
  position: relative;
  width: 100%;
  flex: 1;
  font-size: 16pt;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
}

.box-title-info {
  position: absolute;
  right: 2mm;
  bottom: 2mm;
  font-size: 11pt;
}

.box-item {
  height: 11mm;
  display: flex;
  align-items: center;
}

.width-1 {
  width: 100%;
}

.width-2 {
  width:calc(100% - 35mm);
}

.box-l {
  padding-left: 2mm;
  width: 20mm;
  height: 100%;
  display: flex;
  align-items: center;
}

.box-r {
  padding-left: 2mm;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
}

.box-qrcode {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 32mm;
  height: 32mm;
  padding: 1mm;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media print {
  * {
    padding: 0;
    margin: 0;
  }
  .page {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }
}
            </style>`;
      win.document.write('<' + 'html' + '>' + st + '<' + 'body' + '>');

      win.document.write(dom);
      win.document.write('<' + '/body' + '><' + '/html' + '>');
      win.document.close();
      win.print();
      win.close();
    },

    getQrcodeBydom(index, item) {
      setTimeout(() => {
        let id = '#qrcode' + index;
        let qrcodeItemdiv = document.querySelector(id);
        var qrcodeItem = new qrcode(qrcodeItemdiv, {
          text: item.urlPath,
          width: 120,
          height: 120,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: qrcode.CorrectLevel.H,
        });
        qrcodeItem.style = 'height:100%;wight:100%;';
      }, 0);
    },

    // 获得数据请求方法
    getQrcodes(projectId, moduleType, items) {
      this.show = true;
      this.qrcodeList = [];
      this.loading = true;
      let ids = '';
      items.forEach((item) => {
        ids += item.id + ',';
      });
      this.show = true;

      setTimeout(() => {
        getQrcode({
          projectId: projectId,
          moduleType: moduleType,
          ids: ids,
        }).then((res) => {
          this.moduleType = res.data.moduleType; //判断二维码类型 0：设备 1：区域
          this.qrcodeList = res.data.codePicList; //二维码list
          this.loading = false;
        });
      }, 100);
    },
  },
};
</script>
